import { defineComponent as _defineComponent } from 'vue'
import { ProductArea } from '@newmoon-org/types';
import { watch, ref, computed } from 'vue';

import { formatDate } from '@/service/dateFormatting.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProductAreaModal',
  props: {
    showModal: { type: Boolean },
    productArea: null
  },
  emits: ['close', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as {
  showModal: boolean;
  productArea?: ProductArea;
}




const productArea = ref<Partial<ProductArea>>({
  label: '',
  createdAt: undefined,
  updatedAt: undefined,
});

watch(
  () => props.productArea,
  () => {
    if (!props.productArea) return;
    productArea.value = { ...props.productArea };
  }
);

const canSubmit = computed(() => {
  return !!productArea.value.label;
});

function close() {
  productArea.value = {};
  emit('close', {});
}

function submit() {
  emit('submit', {
    ...productArea.value,
  });
  productArea.value = {};
}

return { __sfc: true,emit, props, productArea, canSubmit, close, submit, formatDate }
}

})